import cn from "classnames";
import { getFileExtensionLabel, getFileCardBgClass, humanFileSize } from "@/shared/utils";
import { CloseIcon } from "@/shared/assets/icons";

interface Props {
  name: string;
  size: number;
  contentType: string;
  onClick?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
}

export default function FileCard({ name, size, contentType, onClick, onRemove, disabled }: Props) {
  const bg = getFileCardBgClass(contentType);
  const ext = getFileExtensionLabel(contentType);

  return (
    <div
      className={cn("relative w-37 h-24 radius-xs p-3 flex flex-col justify-between", bg, onClick && "cursor-pointer")}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") onClick();
            }
          : undefined
      }>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          disabled={disabled}
          className="absolute top-0 right-0 w-7 h-7 flex items-center justify-center content-action-negative cursor-pointer">
          <CloseIcon size={16} />
        </button>
      )}
      <span className="bg-white/90 text-body-bold-2xs text-black px-1.5 py-0.5 radius-2xs self-start">{ext}</span>
      <div className="min-w-0">
        <p className="text-body-regular-xs content-base-primary truncate">{name}</p>
        <p className="text-body-regular-2xs content-base-secondary">{humanFileSize(size)}</p>
      </div>
    </div>
  );
}

